// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

import { OnDemandSessionMembershipsV1 } from './OnDemandSessionMembershipsV1';
import { VcMembershipsV1 } from './VcMembershipsV1';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type EnrollmentRole =
  | 'NOT_ENROLLED'
  | 'BROWSER'
  | 'PRE_ENROLLED_LEARNER'
  | 'LEARNER'
  | 'MENTOR'
  | 'COURSE_ASSISTANT'
  | 'TEACHING_STAFF'
  | 'INSTRUCTOR'
  | 'PARTNER_ADMIN'
  | 'DATA_COORDINATOR'
  | 'SUPER_USER';

export type DistinctionLevel = 'NO_ACHIEVEMENT' | 'NORMAL' | 'DISTINCTION' | 'HONORS';

export type CourseRecord = 'PASSED' | 'NOT_PASSED' | 'NOT_PASSABLE' | 'VERIFIED_PASSED';

export interface CourseGrade {
  score: number;
  distinctionLevel: DistinctionLevel;
  record: CourseRecord;
  timestamp?: number | null;
}

export interface MembershipsV1 {
  id: string;
  userId: number;
  courseId: string;
  role: EnrollmentRole;
  enrolledTimestamp?: number | null;
  lastAccessedTimestamp?: number | null;
  grade?: CourseGrade | null;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface MembershipsV1Connection {
  elements: Array<MembershipsV1> | null;
  linked: {
    onDemandSessionMembershipsV1: Array<OnDemandSessionMembershipsV1> | null;
    vcMembershipsV1: Array<VcMembershipsV1> | null;
  } | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface MembershipsV1ByCodeQuery {
  MembershipsV1: {
    byCode: MembershipsV1Connection | null;
  } | null;
}

export interface MembershipsV1ByCodeQueryVariables {
  code: string;
  includes?: string | null;
}

export interface MembershipsV1ByCodeForUserQuery {
  MembershipsV1: {
    byCodeForUser: MembershipsV1Connection | null;
  } | null;
}

export interface MembershipsV1ByCodeForUserQueryVariables {
  code: string;
  includes?: string | null;
}

export interface MembershipsV1ByExternalUserIdQuery {
  MembershipsV1: {
    byExternalUserId: MembershipsV1Connection | null;
  } | null;
}

export interface MembershipsV1ByExternalUserIdQueryVariables {
  externalUserId: string;
  filter?: string | null;
  activityStatus?: string | null;
  includes?: string | null;
}

export interface MembershipsV1ByUserQuery {
  MembershipsV1: {
    byUser: MembershipsV1Connection | null;
  } | null;
}

export interface MembershipsV1ByUserQueryVariables {
  userId: string;
  filter?: string | null;
  activityStatus?: string | null;
  showHidden?: string | null;
  includes?: string | null;
}

export interface MembershipsV1FindByUserAndCourseQuery {
  MembershipsV1: {
    findByUserAndCourse: MembershipsV1Connection | null;
  } | null;
}

export interface MembershipsV1FindByUserAndCourseQueryVariables {
  userId: string;
  courseIds: string;
  includes?: string | null;
}

export interface MembershipsV1GetQuery {
  MembershipsV1: {
    get: MembershipsV1Connection | null;
  } | null;
}

export interface MembershipsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface MembershipsV1MeQuery {
  MembershipsV1: {
    me: MembershipsV1Connection | null;
  } | null;
}

export interface MembershipsV1MeQueryVariables {
  filter?: string | null;
  activityStatus?: string | null;
  showHidden?: string | null;
  includes?: string | null;
}

export interface MembershipsV1MeByCourseQuery {
  MembershipsV1: {
    meByCourse: MembershipsV1Connection | null;
  } | null;
}

export interface MembershipsV1MeByCourseQueryVariables {
  courseId: string;
  showHidden?: string | null;
  includes?: string | null;
}

export interface MembershipsV1MultiGetQuery {
  MembershipsV1: {
    multiGet: MembershipsV1Connection | null;
  } | null;
}

export interface MembershipsV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface MembershipsV1ByUserAndCourseMutation {
  MembershipsV1: {
    byUserAndCourse: MembershipsV1Connection | null;
  } | null;
}

export interface MembershipsV1ByUserAndCourseMutationVariables {
  userId: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class MembershipsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'memberships.v1' as const;

  id!: string;

  userId!: number;

  courseId!: string;

  role!: EnrollmentRole;

  enrolledTimestamp?: number | null;

  lastAccessedTimestamp?: number | null;

  grade?: CourseGrade | null;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<MembershipsV1>) {
    super(params);
  }
}
